import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const CompanyInfoScreen = ({ handleBackButtonClick, setScreenNumber }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div className={styles.content}>
        <p className={styles.headTitle}>Інформація про компанію</p>
        <p className={styles.text}>
          {'Філіп Морріс Інтернешнл Менеджмент СА (Philip Morris International Management SA),\n\n' +
            'Авеню де Родані, 50, м. Лозанна 1007, Швейцарія\n\n' +
            'Телефон: +41 58 242 0000 pmi.internet@pmi.com\n\n' +
            'Комерційний реєстр кантону Во:Федеральний номер: CH-550-1015211-0 Номер платника ПДВ: CHE-116.276.488\n\n' +
            'ТОВ «Філіп Морріс Сейлз енд Дистриб’юшн» Україна, 04070, м. Київ, вул. Спаська, 30, Код ЄДРПОУ 39540982'}
        </p>
        <p className={styles.title}>Хто ми?</p>
        <p className={styles.text}>
          Ми є членом групи компаній «Філіп Морріс Інтернешнл» (Philip Morris
          International). Детальну інформацію про нас можна знайти на сторінці
          «Інформація про компанію» нижче.
        </p>
        <p className={styles.title}>Як Ви приймаєте ці умови?</p>
        <p className={styles.text}>
          Якщо Ви користуєтеся цим веб-сайтом scanpack.com («Веб-сайт»), Ви
          приймаєте ці умови користування («Умови»). При першому використанні
          Веб-сайту Ваша увага привертається до цих Умов. Це важливі положення,
          що стосуються Вашого використання Веб-сайту: Ви повинні прочитати їх,
          перш ніж використовувати Веб-сайт, оскільки вони є обов’язковими для
          Вас.
        </p>
        <p className={styles.title}>Обмеження відповідальності:</p>
        <p className={styles.text}>
          {'Використовуючи Веб-сайт, Ви приймаєте певні виключення та обмеження нашої відповідальності перед Вами, які ми пояснюємо в цих Умовах і більш детально – в розділі «Обмеження відповідальності» нижче. Коротко: Ви використовуєте Веб-сайт на свій власний ризик; і ми не беремо на себе жодної відповідальності або не надаємо жодних гарантій (чітко виражених або опосередкованих) щодо Веб-сайту або Вашого використання Веб-сайту.\n\n' +
            'ЯКЩО ВИ НЕ ПОГОДЖУЄТЕСЯ З ЦИМИ УМОВАМИ, ВИ НЕ ПОВИННІ ВИКОРИСТОВУВАТИ ВЕБ-САЙТ.'}
        </p>
        <p className={styles.title}>Зміни цих Умов:</p>
        <p className={styles.text}>
          {'Ми не виключаємо або не обмежуємо відповідальність, яка не може бути виключена або обмежена законом, відповідальність за смерть або особисту шкоду, спричинену нашою недбалістю, або відповідальність, що виникає внаслідок навмисного введення в оману або грубої недбалості.\n\n' +
            'Ми не будемо нести відповідальності перед Вами за будь-які втрати або пошкодження, що виникли внаслідок використання Вами Веб-сайту внаслідок порушення цих умов, або через технологічно шкідливий матеріал або дії (такі як вірус або атака типу «відмова в обслуговуванні»), які можуть негативно впливати на ваше комп’ютерне обладнання, комп’ютерні програми, дані або інший матеріал у зв’язку з використанням Вами нашого Веб-сайту або будь-якого веб-сайту, пов’язаному з ним.\n\n' +
            'Ви визнаєте та погоджуєтеся, що функціонування Веб-сайту залежить від правильного та ефективного функціонування Інтернету та іншого обладнання та послуг третьої сторони (включаючи Ваш власний пристрій або веб-браузер), і що ми не гарантуємо та не будемо нести відповідальності за це в будь-якому випадку.\n\n' +
            'Ми не будемо нести відповідальності за будь-які спеціальні, штрафні або непрямі втрати або збитки, або за будь-яку втрату даних, прибутку, доходів, бізнесу чи нематеріальних активів.\n\n' +
            'Якщо ви спричините технічне руйнування Веб-сайту або систем, що передають Веб-сайт Вам чи іншим, Ви погоджуєтеся нести відповідальність за всі втрати, грошові зобов’язання, витрати, збитки та видатки, включаючи розумні збори адвокатів і судові витрати, що виникають з цього руйнування або в результаті нього.'}
        </p>
        <p className={styles.title}>Юрисдикція та застосовне законодавство</p>
        <p className={styles.text}>
          Ці Умови та Ваше використання Веб-сайту регулюються законодавством
          країни або юрисдикції, які ми вказали на сторінці «Інформація про
          компанію» («Юрисдикція») вище. Ви безповоротно погоджуєтесь на
          виключну юрисдикцію судів, що знаходяться в Юрисдикції (і, якщо
          сторони можуть правомірно погодитися, судів у місті, найближчому до
          нашого зареєстрованого офісу), для будь-яких дій щодо примусового
          виконання цих Умов. Веб-сайт був розроблений з урахуванням законів
          Юрисдикції.
        </p>
        <p className={styles.title}>
          Інші важливі права, які ми маємо відповідно до цих Умов
        </p>
        <p className={styles.text}>
          {'Ми можемо передати наші права та обов’язки за цими Умовами іншій організації, але це не вплине на Ваші права згідно з цими Умовами.\n\n' +
            'Якщо ми не наполягатимемо, щоб Ви виконували будь-які Ваші зобов’язання відповідно до цих Умов, або якщо ми не будемо забезпечувати в примусовому порядку реалізацію своїх прав по відношенню до Вас, або якщо ми відкладемо її, це не означатиме, що ми відмовилися від нашого права забезпечувати санкцією таке невиконання по відношенню до Вас, або що Ви не повинні виконувати ці зобов’язання. Якщо ми таки вирішимо відмовитися від нашого права забезпечувати правовою санкцією невиконання або порушення Вами цих Умов, ми зробимо це тільки в письмовій формі.\n\n' +
            'Кожен з пунктів цих Умов діє окремо. Це означає, що якщо будь-який суд або відповідний орган вирішить, що будь-який з них є неправомірним, незаконним або не підлягає виконанню, інші пункти залишатимуться в повній силі та дії.\n\n' +
            'Ці Умови не призначені для надання прав нікому, крім Вас і нас.'}
        </p>
        <p className={styles.title}>Як зв’язатися з нами</p>
        <p className={styles.text}>
          {'Зв’яжіться з нами, написавши лист на електронну адресу support.customer@pmi.com, якщо:\n\n' +
            '• Ви вважаєте, що Веб-сайт порушує Ваші права інтелектуальної власності, або що він містить інформацію, що є незаконною, образливою або порушує Ваші права або права третьої сторони; або\n\n' +
            '• Ви маєте будь-які питання щодо цих Умов або Веб-сайту.'}
        </p>
        <div className={styles.buttonContainer}>
          <button onClick={handleBackButtonClick}>Назад</button>
        </div>
      </div>
      <div className={styles.footerContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(9)}>Умови використання</button>
        <button onClick={() => setScreenNumber(10)}>FAQ</button>
        <button onClick={() => setScreenNumber(11)}>
          Параметри застосування файлів cookie
        </button>
      </div>
    </div>
  );
};

export default CompanyInfoScreen;
